import { DatadogRUM } from '@user-portal/datadog-rum';

import { isProd } from 'helpers/utils';

import { ANALYTICS_CAT_ID } from '@/constants/oneTrust';

export const initDatadogRUM = () => {
    const applicationId = import.meta.env.DD_RUM_APPLICATION_ID;
    const clientToken = import.meta.env.DD_RUM_CLIENT_TOKEN;
    const serviceName = import.meta.env.DD_SERVICE_NAME;
    const env = import.meta.env.ENV;

    const missingRequiredEnvVars = [
        ['DD_RUM_APPLICATION_ID', applicationId],
        ['DD_RUM_CLIENT_TOKEN', clientToken],
        ['DD_SERVICE_NAME', serviceName],
        ['ENV', env],
    ]
        .filter(([, value]) => !value)
        .map(([key]) => key);

    if (missingRequiredEnvVars.length > 0) {
        console.error(
            `Datadog RUM initialization skipped. Missing required environment variables: ${missingRequiredEnvVars.join(
                ', '
            )}`
        );

        return;
    }

    DatadogRUM.init({
        applicationId,
        clientToken,
        serviceName,
        env,
        version: import.meta.env.RELEASE_DATE,
        sessionSampleRate: Number(import.meta.env.DD_RUM_SAMPLING_RATE) || 20,
        replaySampleRate: Number(import.meta.env.DD_SESSIONREPLAY_SAMPLING_RATE) || 0,
        trackingConsent: isProd() ? 'not-granted' : 'granted',
        oneTrustAnalyticsCategoryId: ANALYTICS_CAT_ID,
    });
};
